<template>
  <modal :show="show" :fullscreen="true" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edycja' : 'Dodaj regulamin' }}</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12 px-2>
          <w-schema :model="$schema.name">
            <v-text-field name="name" label="Nazwa*"></v-text-field>
          </w-schema>
        </v-flex>

        <v-flex xs12 px-2>
          <v-layout row wrap>
            <v-flex xs6>
              <w-schema :model="$schema.profileType">
                <v-select
                  label="Typ profilu"
                  item-text="name"
                  item-value="value"
                  :items="profileTypes"
                ></v-select>
              </w-schema>
            </v-flex>

            <v-flex xs6 px-2>
              <w-schema :model="$schema.order">
                <v-text-field label="Kolejność*" type="number"></v-text-field>
              </w-schema>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 px-2>
          <datepicker :schema="$schema.start"></datepicker>
        </v-flex>

        <v-flex xs12 px-2>
          <w-schema :model="$schema.required">
            <v-checkbox label="Wymagany"></v-checkbox>
          </w-schema>
        </v-flex>

        <v-flex class="mb-4" px-2>
          <html-editor v-if="show" :schema="$schema.content"></html-editor>
        </v-flex>

        <v-flex v-if="show" class="mb-4" px-2 :returnNumber="true">
          <media :schema="$schema.mediaId"></media>
        </v-flex>
      </v-layout>

      <span class="caption grey--text">*oznaczone pola są wymagane</span>
    </div>

    <v-layout slot="actions">
      <v-spacer></v-spacer>

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>
<script>
import { WSchema, WSelect } from '@witkac/vuetify-components';
import { ProfileType, ProfileTypeTranslation } from '@witkac/kartamiejska-shared';

import schema from '@/schemas/terms.schema';
import HtmlEditor from '@/components/forms/HtmlEditor';
import { manageMixin } from '@/mixins/manage';
import Modal from '@/components/material/Modal';
import Media from '@/components/forms/Media';

const emptyData = () => ({
  name: '',
  order: null,
  profileType: '',
  required: false,
  content: '',
  mediaId: null,
  start: ''
});
// @vuese
// Modal do dodawania/edycji regulaminów
// @group Terms
export default {
  components: { WSchema, WSelect, Modal, HtmlEditor, Media },
  mixins: [manageMixin('terms', {}, emptyData)],
  schema,
  data() {
    return {
      profileTypes: [
        { name: ProfileTypeTranslation[ProfileType.PARTNER], value: ProfileType.PARTNER },

        { name: ProfileTypeTranslation[ProfileType.OFFICIAL], value: ProfileType.OFFICIAL },

        { name: ProfileTypeTranslation[ProfileType.CLIENT], value: ProfileType.CLIENT }
      ]
    };
  }
};
</script>